import React from 'react';
import {
  NODE_CODEBLOCK,
  NODE_HEADING,
  NODE_PARAGRAPH,
  NODE_QUOTE,
  NODE_UL,
  NODE_LI,
  NODE_BR,
} from 'storyblok-rich-text-react-renderer';

import { Type } from '../Type/Type';
import { Box } from '../Box/Box';

const MarkupCodeblock = (children, { class: className }) => (
  <pre>
    <Type as="code" className={className}>
      {children}
    </Type>
  </pre>
);

const MarkupHeading = (children, { level }) => (
  <Type as={`h${level}`} className="ff-type">
    {children}
  </Type>
);

const MarkupParagraph = (children) => (
  <Type as="p" className="ff-type">
    {children}
  </Type>
);

const MarkupQuote = (children) => <Type as="blockquote">{children}</Type>;

const MarkupUnorderedList = (children) => (
  <ul style={{ listStyle: 'disc' }} className="ff-type pl-10">
    {children}
  </ul>
);

const MarkupListItem = (children) => <li>{children}</li>;

const MarkupBreak = () => (
  <Box as="div">
    <br />
  </Box>
);

const nodeResolvers = {
  [NODE_CODEBLOCK]: MarkupCodeblock,
  [NODE_HEADING]: MarkupHeading,
  [NODE_PARAGRAPH]: MarkupParagraph,
  [NODE_QUOTE]: MarkupQuote,
  [NODE_UL]: MarkupUnorderedList,
  [NODE_LI]: MarkupListItem,
  [NODE_BR]: MarkupBreak,
};

export default nodeResolvers;
